import {useApiCreate} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornScreen} from "../../../../../application/business/StubbornAsset";

export const useEditionScreenCreate = () => useApiCreate<StubbornScreen>(PATH);
